<template>
    <div class="home progress">
        <el-form>
            <div>
                <el-steps :active="a" align-center>
                    <el-step title="申请提交" icon="el-icon-edit"></el-step>
                    <el-step title="办公厅公开办已受理" icon="el-icon-upload"></el-step>
                    <el-step title="办理回复" icon="el-icon-picture"></el-step>
                    <el-step title="办理回复" icon="el-icon-error"></el-step>
                </el-steps>
            </div>
            <div class="content">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <span class="text">xxxxxxxxxxxxxxx</span>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="q">下载</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="footer">
                <el-button type="primary" @click="route_goFun3('表格展示')">返回</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                a: 0,
                form: {}
            }
        },
        mounted() {

        },
        methods: {
            q() {
                this.a = 1
            },
            // 返回查看申请表格
            route_goFun3(name) {
                this.$router.push({
                    path: '/select-result-table',
                    query: {
                        name: name,
                        id: 3,
                        tel: this.form.tel,
                        certificateNo: this.form.certificateNo,
                        pageSize: ' '
                    }
                })
            }

        }
    }

</script>
<style>
    .progress {
        text-align: center;
        width: 60%;
        /*margin: 0 auto;*/
        padding: 20px 10px;
        margin-top: 100px;
    }

    .progress .content {
        margin-top: 60px;
        margin-bottom: 40px;
        /*text-align: end;*/
    }

    .progress .content .text {
        margin-right: 20px;
    }

    .progress .footer {
        margin-top: 20px;
        margin-bottom: 40px;
    }
</style>
